import request from '@/utils/request'

export function getTime() {
  return request({
    url: '/ywpx/im/time',
    method: 'get'
  })
};

export function save(source,target,message) {
  return request({
    url: '/ywpx/im/messages',
    method: 'post',
    data:{source:source,target:target,message:message}
  })
};

export function updateReaded(id) {
  return request({
    url: '/ywpx/im/messages',
    method: 'put',
    data:{'id':id}
  })
};

export function unread(target) {
  return request({
    url: '/ywpx/im/messages/unread',
    method: 'post',
    data:{target:target}
  })
};






